import { httpwmsapi } from 'src/services';
import queryString from 'query-string';

// Action Types
export const Types = {
  MOVEMENT_FORECAST_LOADING: 'movement_forecast/loading',

  MOVEMENT_FORECAST_SET_DATA: 'movement_forecast/set/data',
  MOVEMENT_FORECASTS_SET_DATA: 'movement_forecast/set/datas',
  MOVEMENT_FORECAST_SET_PAGING: 'movement_forecast/set/paging',
  MOVEMENT_FORECAST_FILTERS_CHIP: 'movement_forecast/set/filter_chip',
  MOVEMENT_FORECAST_SET_FILTER: 'movement_forecast/set/filter',
};

// Reducer
const initialState = {
  loading: false,

  movement_forecast: {},
  movement_forecasts: [],
  movement_forecast_paging: { limit: 25, offset: 0, total: 0, page: 0 },
  movement_forecast_filters_chip: [],
  movement_forecast_filters: [],
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.MOVEMENT_FORECAST_LOADING:
      return { ...state, loading: action.payload };

    case Types.MOVEMENT_FORECAST_SET_DATA:
      return { ...state, movement_forecast: action.payload };
    case Types.MOVEMENT_FORECASTS_SET_DATA:
      return { ...state, movement_forecasts: action.payload };
    case Types.MOVEMENT_FORECAST_SET_PAGING:
      return { ...state, movement_forecast_paging: action.payload };
    case Types.MOVEMENT_FORECAST_FILTERS_CHIP:
      return { ...state, movement_forecast_filters_chip: action.payload };
    case Types.MOVEMENT_FORECAST_SET_FILTER:
      return { ...state, movement_forecast_filters: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  movementForecastLoading: (value) => ({ type: Types.MOVEMENT_FORECAST_LOADING, payload: value }),

  movementForecastSetData: (movementForecast) => ({
    type: Types.MOVEMENT_FORECAST_SET_DATA,
    payload: movementForecast,
  }),
  movementForecastsSetData: (movementForecasts) => ({
    type: Types.MOVEMENT_FORECASTS_SET_DATA,
    payload: movementForecasts,
  }),
  movementForecastSetPaging: (movementForecast_paging) => ({
    type: Types.MOVEMENT_FORECAST_SET_PAGING,
    payload: movementForecast_paging,
  }),
  movementForecastSetFiltersChip: (movementForecast_filters_chip) => ({
    type: Types.MOVEMENT_FORECAST_FILTERS_CHIP,
    payload: movementForecast_filters_chip,
  }),
  movementForecastSetFilters: (movementForecast_filters) => ({
    type: Types.MOVEMENT_FORECAST_SET_FILTER,
    payload: movementForecast_filters,
  }),

  getMovementForecasts: (filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' }).replaceAll('%5B', '[').replaceAll('%5D', ']');
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/movimentacao/previsao-movimentacao?${qry}`, {
          timeout: 1000 * 50,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};
